import React, { useCallback } from "react";

import { KPIEditSectionsListItem } from "./KPIEditSectionsListItem";
import { graphql, useFragment } from "react-relay";
import { useIntlTokens } from "../../../../components/mobile/useIntlTokens";
import { KPIEditSectionsSectionHeader_Team$key } from "./__generated__/KPIEditSectionsSectionHeader_Team.graphql";
import { useAlert } from "../../../../common/Alert";
import { useIntl } from "react-intl";

export function KPIEditSectionsSectionHeader(props: {
  isFirst: boolean;
  isLast: boolean;

  hasGoal: boolean;
  hasSubTeam: boolean;

  goalDirection: "greater" | "less";
  goalValue: number;

  team: KPIEditSectionsSectionHeader_Team$key;

  onRemoveSection?(): void;
  onAddSubTeam?(): void;
  setGoalValue(_: number): void;
}) {
  const intl_tokens = useIntlTokens();
  const team = useFragment(
    graphql`
      fragment KPIEditSectionsSectionHeader_Team on Team {
        color
        icon
        name
      }
    `,
    props.team
  );

  const Alert = useAlert();
  const intl = useIntl();
  // `Vill du ta bort mätområdet ${team.name}?`
  const onRemoveTeam = useCallback(() => {
    Alert.alert(
      intl.formatMessage({
        description: "KPIEditSectionsSectionHeader alert title",

        defaultMessage: "Delete section",
      }),
      intl.formatMessage(
        {
          description: "KPIEditSectionsSectionHeader alert description",
          defaultMessage: "Do you want to delete the section {name}?",
        },
        {
          name: team.name,
        }
      ),
      [
        {
          style: "destructive",
          text: intl_tokens.Delete,
          onPress: props.onRemoveSection,
        },
        {
          style: "cancel",
          text: intl_tokens.Cancel,
        },
      ]
    );
  }, [
    Alert,
    intl,
    intl_tokens.Cancel,
    intl_tokens.Delete,
    props.onRemoveSection,
    team.name,
  ]);
  return (
    <KPIEditSectionsListItem
      team={{
        color: team.color,
        icon: team.icon,
      }}
      space="medium"
      spaceHorizontal="medium"
      spaceBottom={props.hasSubTeam ? "none" : undefined}
      dynamicHeight
      isFirst={props.isFirst}
      isLast={props.isLast}
      goalDirection={props.goalDirection}
      goalValue={props.goalValue}
      onAddSubsection={props.hasSubTeam ? undefined : props.onAddSubTeam}
      onRemove={!props.hasSubTeam ? onRemoveTeam : undefined}
      setGoalValue={
        !props.hasSubTeam && props.hasGoal ? props.setGoalValue : undefined
      }
      name={team.name}
    />
  );
}
